'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import type { ButtonProps, ButtonSize } from '@/ui/buttons/button/Button.client'
import { Button } from '@/ui/buttons/button/Button.client'
import { Icon } from '@/ui/icons/icon/Icon'

export type CloseButtonProps = StrictPick<
  ButtonProps,
  'onPress' | 'slot' | 'isDisabled' | 'className' | 'data-testid'
> & {
  variant?: 'tertiary' | 'secondary' | 'quaternary'
  size?: ButtonSize
  /** Overrides the default translated close label, used as the accessible name */
  children?: string
}

export function CloseButton({
  onPress,
  slot,
  variant = 'tertiary',
  size = 'sm',
  isDisabled,
  className,
  'data-testid': dataTestId,
  children,
}: CloseButtonProps) {
  const { t } = useTranslation(['generic'])

  return (
    <Button
      size={size}
      onPress={onPress}
      slot={slot}
      variant={variant}
      isRound
      iconLeft={<Icon.X />}
      isDisabled={isDisabled}
      className={className}
      data-testid={dataTestId}
    >
      {children ?? t('generic:actions.close')}
    </Button>
  )
}
